import type { Status, UserBundleAccess } from "@/types";
import type { ServiceResponse } from "./api.types";
import { privateAPI } from "./axios";

export const getUserBundleAccesses = async (
  page: number,
  searchQuery = "",
  bundleIds: string[] = [],
  statuses: Status[] = [],
  userId?: string,
  pageSize?: number,
): Promise<ServiceResponse<UserBundleAccess[]>> => {
  const params: Record<string, string | number> = {
    include: "bundle,user",
    page,
  };
  if (pageSize) {
    params.pageSize = pageSize;
  }
  if (bundleIds.length > 0) {
    bundleIds.forEach((bundle, index) => {
      params[`filter[bundle][${index}]`] = bundle;
    });
  }

  if (statuses.length > 0) {
    statuses.forEach((status, index) => {
      params[`filter[status][${index}]`] = status;
    });
  }

  if (searchQuery) {
    params["filter[userSearch]"] = searchQuery;
  }

  if (userId) {
    params["filter[user]"] = userId;
  }

  const response = await privateAPI.get<ServiceResponse<UserBundleAccess[]>>(
    "/user-bundle-access",
    { params },
  );

  return response.data;
};

export const adminGrantBundleAccess = async ({
  userId,
  bundleId,
  accessStartDate,
  accessEndDate,
}: {
  userId: string;
  bundleId: string;
  accessStartDate?: string | null;
  accessEndDate?: string | null;
}) => {
  await privateAPI.post<void>("/user-bundle-access/admin-grant", {
    user_id: userId,
    bundle_id: bundleId,
    access_start_date: accessStartDate ?? null,
    access_end_date: accessEndDate ?? null,
  });
};

export const updateUserBundleAccess = async ({
  userBundleAccessId,
  status,
  accessStartDate,
  accessEndDate,
}: {
  userBundleAccessId: UserBundleAccess["id"];
  status: Status;
  accessStartDate?: string | null;
  accessEndDate?: string | null;
}) => {
  await privateAPI.put<void>(`/user-bundle-access/${userBundleAccessId}`, {
    status,
    access_start_date: accessStartDate ?? null,
    access_end_date: accessEndDate ?? null,
  });
};
